import { EComponentType, IComponent, IScene } from '@/helpers/editor';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import AlertBoxTemplate from '@/components/editor/templates/AlertBoxTemplate.vue';
import ImageTemplate from '@/components/editor/templates/ImageTemplate.vue';
import TextTemplate from '@/components/editor/templates/TextTemplate.vue';
import VideoTemplate from '@/components/editor/templates/VideoTemplate.vue';
import CustomComponentTemplate from '@/components/editor/templates/CustomComponentTemplate.vue';
import ChatTemplate from '@/components/editor/templates/ChatTemplate.vue';
import EventListTemplate from '@/components/editor/templates/EventListTemplate.vue';

@Component({
  components: {},
})
export default class ScenePreview extends EditorBase {
  @Prop({ required: true })
  scene: IScene;

  @Prop({ default: 720 })
  height: number;

  $refs!: {
    scenePreview: HTMLElement;
  };

  previewScale: number = 1;

  get components(): IComponent[] {
    return this.scene.components;
  }

  get width(): number {
    return this.height / 9 * 16;
  }

  @Watch('scene', { deep: true })
  calculatePreviewScale() {
    let availableHeight: number = this.height;
    let availableWidth: number = this.width;

    if (this.$refs.scenePreview) {
      availableWidth = this.$refs.scenePreview.offsetWidth;
      availableHeight = this.$refs.scenePreview.offsetHeight;
    }

    this.previewScale = Math.min(
      availableWidth / this.width,
      availableHeight / this.height,
    );
  }

  get transformCss() {
    return {
      transform: `translate(
        ${-this.width / 2}px,
        ${-this.height / 2}px)
        scale(${this.previewScale})`,
      width: `${this.width}px`,
      height: `${this.height}px`,
      position: 'absolute',
      top: '50%',
      left: '50%',
      borderRadius: `${2 / this.previewScale}px`,
    };
  }

  componentTemplate(component: IComponent) {
    switch (component.type) {
      case EComponentType.text:
        return TextTemplate;
      case EComponentType.image:
        return ImageTemplate;
      case EComponentType.video:
        return VideoTemplate;
      case EComponentType.alertBox:
        return AlertBoxTemplate;
      case EComponentType.customComponent:
        return CustomComponentTemplate;
      case EComponentType.chat:
        return ChatTemplate;
      case EComponentType.eventList:
        return EventListTemplate;
      default:
        return null;
    }
  }

  templateData(component: IComponent, index: number) {
    return {
      component,
      zIndex: this.scene.components.length - index,
      isSceneThumbnail: true,
    };
  }

  mounted() {
    this.calculatePreviewScale();
  }
}
